import { TextField, TextFieldProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const MobileTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 12,
    fontSize: 16,
    backgroundColor: 'transparent',
    '& fieldset': {
      borderColor: theme.palette.divider,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.divider,
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-focused': {
      backgroundColor: 'transparent',
      '& fieldset': {
        borderColor: theme.palette.divider,
      },
    },
  },
  '& .MuiOutlinedInput-input': {
    fontSize: 16,
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px white inset',
      WebkitTextFillColor: theme.palette.text.primary,
    },
  },
  '& .MuiFormHelperText-root': {
    fontSize: 14,
    marginLeft: 0,
  },
}));

export default MobileTextField;
